import React from 'react';
import { AlertCircle } from 'lucide-react';

interface RatingScaleProps {
  value: number | null;
  onChange: (value: number) => void;
  error?: string;
  disabled?: boolean;
}

const LABELS: Record<number, string> = {
  1: 'Muito abaixo',
  2: 'Abaixo',
  3: 'Dentro do esperado',
  4: 'Acima',
  5: 'Muito acima',
};

export const RatingScale: React.FC<RatingScaleProps> = ({ value, onChange, error, disabled }) => (
  <div>
    <div className="flex gap-2">
      {[1, 2, 3, 4, 5].map(n => (
        <button
          key={n}
          type="button"
          disabled={disabled}
          onClick={() => onChange(n)}
          title={LABELS[n]}
          className={[
            'w-10 h-10 rounded-lg text-sm font-semibold border transition-colors',
            value === n
              ? 'bg-blue-600 text-white border-blue-600'
              : 'bg-white text-gray-700 border-gray-300 hover:border-blue-400 hover:text-blue-600',
            disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer',
          ].join(' ')}
        >
          {n}
        </button>
      ))}
      {value && (
        <span className="self-center text-xs text-gray-500 ml-1">{LABELS[value]}</span>
      )}
    </div>
    {error && (
      <p className="mt-1 text-sm text-red-600 flex items-center gap-1">
        <AlertCircle className="w-4 h-4 flex-shrink-0" />
        {error}
      </p>
    )}
  </div>
);
